import {
  createSidebarConfig,
  createMenuItem,
  createPermissionMenuItem,
  createModuleAdminMenuItem,
  createSubMenuItem,
  createAutoExpandConfig,
} from "./SidebarUtils";
import accountingLogo from "../../modules/accounting/assets/accounting-logo.png";
import textLogo from "../../assets/logo/text-logo.png";

// Example: Accounting Module Configuration
export const createAccountingSidebarConfig = () => {
  return createSidebarConfig(
    accountingLogo,
    "VenFlows Finance",
    [
      createPermissionMenuItem(
        "dashboard",
        "Dashboard",
        "/accounting/dashboard",
        "accounting.dashboard.view",
        { icon: "dashboard" }
      ),
      createPermissionMenuItem(
        "chart-of-accounts",
        "Chart of Accounts",
        "/accounting/chart-of-accounts",
        "accounting.chart_of_accounts.view",
        { icon: "account_tree" }
      ),
      createPermissionMenuItem(
        "journals",
        "Journals",
        "/accounting/journals",
        "accounting.journals.view",
        { icon: "book" }
      ),
      createPermissionMenuItem(
        "vouchers",
        "Vouchers",
        "/accounting/vouchers",
        "accounting.vouchers.view",
        {
          icon: "receipt",
          subItems: [
            createSubMenuItem(
              "voucher-entries",
              "Voucher Entries",
              "/accounting/vouchers",
              {
                icon: "receipt_long",
                permission: "accounting.vouchers.view",
              }
            ),
            createSubMenuItem(
              "voucher-templates",
              "Voucher Templates",
              "/accounting/vouchers/templates",
              {
                icon: "description",
                permission: "accounting.voucher_templates.view",
              }
            ),
          ],
        }
      ),
      createPermissionMenuItem(
        "ledger",
        "Ledger",
        "/accounting/ledger",
        "accounting.ledger.view",
        { icon: "account_balance" }
      ),
      createModuleAdminMenuItem(
        "configuration",
        "Configuration",
        "/accounting/configuration",
        {
          icon: "tune",
          subItems: [
            createSubMenuItem(
              "configuration-dashboard",
              "Dashboard",
              "/accounting/configuration",
              {
                icon: "dashboard",
                requiresModuleAdmin: true,
              }
            ),
            createSubMenuItem(
              "coa-mappings",
              "COA Mappings",
              "/accounting/configuration/coa-mappings",
              {
                icon: "account_tree",
                requiresModuleAdmin: true,
              }
            ),
            createSubMenuItem(
              "voucher-settings",
              "Voucher Settings",
              "/accounting/configuration/voucher-settings",
              {
                icon: "receipt",
                requiresModuleAdmin: true,
              }
            ),
            createSubMenuItem(
              "journal-settings",
              "Journal Settings",
              "/accounting/configuration/journal-settings",
              {
                icon: "book",
                requiresModuleAdmin: true,
              }
            ),
            createSubMenuItem(
              "ledger-settings",
              "Ledger Settings",
              "/accounting/configuration/ledger-settings",
              {
                icon: "account_balance",
                requiresModuleAdmin: true,
              }
            ),
            // createSubMenuItem(
            //   "permissions",
            //   "Permissions",
            //   "/accounting/configuration/permissions",
            //   {
            //     icon: "security",
            //     requiresModuleAdmin: true,
            //   }
            // ),
          ],
        }
      ),
    ],
    {
      moduleName: "accounting",
      defaultWidth: 280,
      autoExpandPaths: createAutoExpandConfig([
        { menuId: "configuration", pathPrefix: "/accounting/configuration" },
        { menuId: "vouchers", pathPrefix: "/accounting/vouchers" },
      ]),
    }
  );
};

// Example: Business Admin Module Configuration
export const createBusinessAdminSidebarConfig = () => {
  return createSidebarConfig(
    textLogo,
    "VenFlows Business",
    [
      createPermissionMenuItem(
        "dashboard",
        "Dashboard",
        "/business",
        "business.dashboard.view",
        { icon: "insights" }
      ),
      createPermissionMenuItem(
        "stock-management",
        "Stock Management",
        "/business/stock-management",
        "business.stock.view",
        {
          icon: "inventory_2",
          subItems: [
            createSubMenuItem(
              "stock_adjustment",
              "Stock Adjustment",
              "/business/stock-management/stock-adjustment",
              {
                icon: "tune",
                permission: "business.stock.adjustment.view",
              }
            ),
            createSubMenuItem(
              "raw_materials",
              "Raw Materials",
              "/business/stock-management/raw-materials",
              {
                icon: "spa",
                permission: "business.ingredients.view",
              }
            ),
          ],
        }
      ),
      createPermissionMenuItem(
        "kitchen",
        "Kitchen",
        "/business/kitchen",
        "business.kitchen.view",
        {
          icon: "kitchen",
          subItems: [
            createSubMenuItem(
              "recipes",
              "Recipes",
              "/business/kitchen/recipes",
              {
                icon: "restaurant_menu",
                permission: "business.recipes.view",
              }
            ),
            createSubMenuItem(
              "processed_items",
              "Processed Items",
              "/business/kitchen/API",
              {
                icon: "lunch_dining",
                permission: "business.processed.items.view",
              }
            ),
          ],
        }
      ),
      createPermissionMenuItem(
        "menu",
        "Menu",
        "/business/menu",
        "business.menu.view",
        {
          icon: "restaurant_menu",
          subItems: [
            createSubMenuItem("bom", "BOM", "/business/menu/bom", {
              icon: "list_alt",
              permission: "business.bom.view",
            }),
            createSubMenuItem(
              "sale_items",
              "Sale Items",
              "/business/menu/sale-items",
              {
                icon: "fastfood",
                permission: "business.sale.items.view",
              }
            ),
            createSubMenuItem(
              "menu_items",
              "Menu Items",
              "/business/menu/menu-items",
              {
                icon: "menu_book",
                permission: "business.menu.items.view",
              }
            ),
          ],
        }
      ),
      createPermissionMenuItem(
        "orders",
        "Orders",
        "/business/orders",
        "business.orders.view",
        { icon: "receipt_long" }
      ),
      createPermissionMenuItem(
        "procurement",
        "Procurement",
        "/business/procurement",
        "business.procurement.view",
        {
          icon: "shopping_cart",
          subItems: [
            createSubMenuItem(
              "purchase-requests",
              "Purchase Requests",
              "/business/procurement/requests",
              {
                icon: "list_alt",
                permission: "business.purchase.requests.view",
              }
            ),
            createSubMenuItem("RFQ", "RFQ", "/business/procurement/RFQ", {
              icon: "request_quote",
              permission: "business.rfq.view",
            }),
            createSubMenuItem(
              "purchase-orders",
              "Purchase Orders",
              "/business/procurement/purchase-orders",
              {
                icon: "shopping_cart",
                permission: "business.purchase.orders.view",
              }
            ),
            createSubMenuItem("grn", "GRN", "/business/procurement/grn", {
              icon: "inventory",
              permission: "business.grn.view",
            }),
            createSubMenuItem(
              "invoices",
              "Invoices",
              "/business/procurement/invoices",
              {
                icon: "receipt",
                permission: "business.invoices.view",
              }
            ),
          ],
        }
      ),
      createPermissionMenuItem(
        "configuration",
        "Configuration",
        "/business/configuration",
        "business.configuration.view",
        {
          icon: "admin_panel_settings",
          subItems: [
            createSubMenuItem(
              "staff",
              "Staff",
              "/business/configuration/staff",
              {
                icon: "people",
                permission: "business.staff.view",
              }
            ),
            createSubMenuItem(
              "branch",
              "Branches",
              "/business/configuration/branches",
              {
                icon: "store",
                permission: "business.branches.view",
              }
            ),
            createSubMenuItem(
              "warehouse",
              "Warehouses",
              "/business/configuration/warehouses",
              {
                icon: "warehouse",
                permission: "business.warehouses.view",
              }
            ),
            createSubMenuItem(
              "department",
              "Departments",
              "/business/configuration/departments",
              {
                icon: "domain",
                permission: "business.departments.view",
              }
            ),
            createSubMenuItem(
              "suppliers",
              "Suppliers",
              "/business/configuration/suppliers",
              {
                icon: "handshake",
                permission: "business.suppliers.view",
              }
            ),
            createSubMenuItem(
              "role",
              "Roles",
              "/business/configuration/roles",
              {
                icon: "manage_accounts",
                permission: "business.roles.view",
              }
            ),
            createSubMenuItem(
              "pos_configuration",
              "POS Configuration",
              "/business/configuration/pos-configuration",
              {
                icon: "point_of_sale",
                permission: "business.pos.configuration.view",
              }
            ),
            createSubMenuItem(
              "tables_configuration",
              "Tables Configuration",
              "/business/configuration/tables-configuration",
              {
                icon: "table_restaurant",
                permission: "business.tables.configuration.view",
              }
            ),
          ],
        }
      ),
      createPermissionMenuItem(
        "settings",
        "Settings",
        "/business/settings",
        "business.settings.view",
        { icon: "settings" }
      ),
    ],
    {
      // Note: Business admin doesn't have module admin concept since it's the main ERP system
      defaultWidth: 280,
      autoExpandPaths: createAutoExpandConfig([
        {
          menuId: "stock-management",
          pathPrefix: "/business/stock-management",
        },
        { menuId: "kitchen", pathPrefix: "/business/kitchen" },
        { menuId: "menu", pathPrefix: "/business/menu" },
        { menuId: "procurement", pathPrefix: "/business/procurement" },
        { menuId: "configuration", pathPrefix: "/business/configuration" },
      ]),
    }
  );
};
